export enum PersonRoles {
  Member = 'Member',
  GGPointOfContact = 'GGPointOfContact',
}
